import { GridColDef } from '@mui/x-data-grid';
import { Section } from '../../../../../interfaces/Stocks/Warehouses/sections';
import { useDates } from '../../../../../hooks/useDates';
import { useTranslation } from 'react-i18next';

export const useColumnsSections = () => {
  const { TimeConverter } = useDates();
  const [t] = useTranslation("global");


  const columnsSections: GridColDef<Section>[] = [
    { field: 'section_name', headerName: t("sections.fields.section_name"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'section_description', headerName: t("sections.fields.section_description"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'creation_date', headerName: t("generic.creation_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params: any) {
        return TimeConverter(params.value);
      },
    },
    { field: 'last_update_user', headerName: t("generic.last_update_user"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'last_update_date', headerName: t("generic.last_update_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params: any) {
        return TimeConverter(params.value);
      },
    },
  ];

  return {
    columnsSections,
  }
}
